import {selectSearchQueryParams} from '@computerrock/formation-router/sagas';
import savScreenTabs from '../../service-assignments-vehicle/savScreenTabs';
import config from '../../config';
import filterContractPartnersByLocation from './filterContractPartnersByLocation';
import filterContractPartnersBySearchQuery from './filterContractPartnersBySearchQuery';
import savaScreenTabs from '../../service-assignments-vehicle-additional/savaScreenTabs';
import sapScreenTabs from '../../service-assignments-pickup/sapScreenTabs';

const searchServiceAssignmentContractPartners = function* searchServiceAssignmentContractPartners({payload}) {
    const {serviceCaseId, serviceAssignmentLineNo, searchQuery} = payload;
    const {activeTab} = yield* selectSearchQueryParams();
    if (activeTab !== savScreenTabs.CONTRACT_PARTNER
        && activeTab !== savaScreenTabs.CONTRACT_PARTNER
        && activeTab !== sapScreenTabs.SERVICE_PROVIDER) return;

    if (config.IS_FALLBACK_SYSTEM) {
        searchQuery
            ? yield* filterContractPartnersBySearchQuery(serviceCaseId, serviceAssignmentLineNo, searchQuery)
            : yield* filterContractPartnersByLocation(serviceCaseId, serviceAssignmentLineNo);
    }
};

export default searchServiceAssignmentContractPartners;
